import React, { useEffect, useState } from "react";

import { ElementState, Preview } from "@creatomate/preview";
import { NumberField } from "@culturehq/components";
import { SelectValue, SelectValueWithCategory } from "@culturehq/components/dist/components/form/typings";

import { Trans } from "app/utils";
import TextProperty from "./StringValueProperty";
import { COLOR_FILTER, IMAGE_TYPE, VIDEO_TYPE } from "../../utils/constants";

interface ColorFilterProps {
  activeElement: ElementState;
  preview: Preview;
  useDefaultValue: boolean;
}

const ColorFilter: React.FC<ColorFilterProps> = ({
  activeElement, preview, useDefaultValue
}) => {
  const [colorFilter, setColorFilter] = useState<null | SelectValue | SelectValueWithCategory>("none");

  useEffect(
    () => {
      if (activeElement.source.type === VIDEO_TYPE || activeElement.source.type === IMAGE_TYPE) {
        setColorFilter(activeElement.source.color_filter || "none");
      }
    }, [activeElement]
  );

  const handleColorFilterChange = async (value: null | SelectValue | SelectValueWithCategory) => {
    setColorFilter(value);
  };

  const handleColorFilterValueChange = async (value: string) => {
    const colorFilterValue = Math.max(+value, 0);
    if (colorFilterValue <= 100) {
      await preview.applyModifications({
        [`${activeElement.source.id}.color_filter_value`]: colorFilterValue
      });
    }
  };

  return (
    <div className="chq-ffd-color">
      <div className="chq-ffd-color-filter">
        <TextProperty
          onChange={handleColorFilterChange}
          activeElement={activeElement}
          defaultValue="none"
          name="color_filter"
          options={COLOR_FILTER}
          required
          preview={preview}
          propertyName="color_filter"
          useDefaultValue={useDefaultValue}
        >
          <Trans>Color Filter</Trans>
        </TextProperty>
      </div>
      <div className="chq-ffd-filter-value">
        <NumberField
          disabled={colorFilter === "none"}
          name="color-filter-value"
          max={100}
          min={0}
          value={activeElement.source.color_filter_value || "0"}
          onChange={handleColorFilterValueChange}
        >
          <Trans>Value</Trans>
        </NumberField>
      </div>
    </div>
  );
};

export default ColorFilter;
